import { useAppStore } from "../../stores/RootStore";
import { useFetch } from "../useFetch";
import { useEffect } from "react";
import { FShift, Shift } from "../../types/types";
import { DateTime } from "luxon";

export const useRefreshShifts = () => {
  const setShifts = useAppStore((store) => store.setShifts);
  const setCurrentShift = useAppStore((store) => store.setCurrentShift);

  const [{ response: shiftsData }, doFetchShifts] = useFetch(`/directories/working_shifts`);

  useEffect(() => {
    let base_shift = {
      id: "full",
      name: "Полный день",
      start_at: DateTime.local().startOf("day"),
      end_at: DateTime.local().endOf("day"),
      working_shift_breaks: [],
    };

    if (shiftsData) {

      let shifts = (shiftsData?.data as unknown as Shift[]).map((s) => {
        // Пересборка того что приходит с бэка
        let start = DateTime.fromISO(s.attributes.started_at)
        let end = DateTime.fromISO(s.attributes.ended_at)
        let build_start = DateTime.fromObject({year: 2000, month: 1, day: 1, hour: start.hour, minute: start.minute, second: start.second})
        let build_end = DateTime.fromObject({year: 2000, month: 1, day: 1, hour: end.hour, minute: end.minute, second: end.second})

        return {
          id: s.id, 
          name: s.attributes.name,
          start_at: build_start ,
          end_at: build_end,
          working_shift_breaks: s.attributes.working_shift_breaks,
        }
      })

      let site_shifts = [base_shift, ...shifts] as FShift[];
      setShifts(site_shifts);
      setCurrentShift(base_shift);
    }
  }, [shiftsData]);

  return doFetchShifts;
};
